import { useEffect, useState } from "@wordpress/element";
import useSWR from "swr";
import { fetcher } from "../fetcher";
import { Job, Loader } from "../_components/job/job";
import qs from "qs";

/**
 * This block renders a list of job offers.
 * Possible parameters:
 * -
 * - count: the number of jobs to display. (optional, default: 3), This is in fact initial count.
 * - sort: the sort order of the jobs. (optional, default: newest)
 * - category: the category of the jobs. (optional, default: all)
 *   category is actually a position
 *
 * - button: a button element that will be used to increase the number of jobs displayed. (optional)
 * newest,
 * similar ? (on offer record page - for experienced and untrained)
 */

// experience
// category_id
// count
export function Block({ count = 3, button, ...props }) {
	const [state, set] = useState(Number(count));

	const params = qs.stringify(
		{ count: state, ...props },
		{
			addQueryPrefix: true,
			filter: (_, value) => value || undefined,
		},
	);

	const jobs = useSWR(`/wp-json/steam-api/jobs${params}`, fetcher, {
		keepPreviousData: true,
	});

	const content = jobs.data?.content ?? [];

	useEffect(() => {
		if (button) {
			button.addEventListener("click", () => set((count) => count + 3));
		}
	}, []);

	const hasContent = content.length > 0;

	return (
		<>
			{hasContent && content.map((i) => <Job key={i.id} offer={i} />)}

			{!hasContent &&
				jobs.isLoading &&
				[...Array(state)].map((_, i) => <Loader key={i} />)}

			{!hasContent && !jobs.isLoading && <>Brak ofert w danych filtrach</>}
		</>
	);
}
